import React, { useEffect, useState } from 'react';

/**
 * Contact footer — shared across rare disease pages.
 * Renders a "Get in touch" block with a mailto link to support@macarowni.com.
 */
export default function ContactFooter() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const mono = { fontFamily: "'IBM Plex Mono', monospace" };

  return (
    <div style={{
      background: '#07080a',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: isMobile ? '2.5rem 1.2rem' : '3.5rem 2rem',
      textAlign: 'center',
    }}>
      <div style={{ maxWidth: '560px', margin: '0 auto' }}>
        <div style={{
          ...mono,
          fontSize: '0.6rem',
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: '#929db3',
          marginBottom: '1rem',
        }}>
          Get in touch
        </div>
        <p style={{
          ...mono,
          fontSize: isMobile ? '0.72rem' : '0.78rem',
          color: '#929db3',
          lineHeight: 1.8,
          marginBottom: '1.2rem',
        }}>
          Have suggestions, corrections, or want to collaborate? I&apos;d love to hear from you.
        </p>
        <a
          href="mailto:support@macarowni.com"
          style={{
            ...mono,
            display: 'inline-block',
            fontSize: isMobile ? '0.85rem' : '0.95rem',
            color: '#00e5b0',
            textDecoration: 'none',
            letterSpacing: '0.04em',
            borderBottom: '1px solid rgba(0,229,176,0.4)',
            paddingBottom: '0.15rem',
            transition: 'color 0.2s, border-color 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = '#33f0c8';
            e.currentTarget.style.borderBottomColor = 'rgba(51,240,200,0.7)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '#00e5b0';
            e.currentTarget.style.borderBottomColor = 'rgba(0,229,176,0.4)';
          }}
        >
          support@macarowni.com
        </a>
      </div>
    </div>
  );
}
